import { fg } from '@atlaskit/platform-feature-flags/fg';

import { ApplicationModes } from '../../common/constants/application-modes';
import { useAppContext } from '../../common/ui/app-context';
import { useApplicationMode } from '../store/bootstrap';

export const useAreLLMPoweredFeaturesEnabled = (): boolean => {
	const { isAdminHubAIEnabled, isRovoLLMEnabled } = useAppContext();
	const applicationMode = useApplicationMode();

	// TODO: QS-6660 clean up the Unified Mode condition once it's decommissioned
	if (applicationMode === ApplicationModes.Unified) {
		return isAdminHubAIEnabled;
	}

	if (fg('rovo_search_updated_entitlement_checks_for_team_25')) {
		return isRovoLLMEnabled;
	}

	return true;
};
